<template>
  <div class="text-left">
    <v-row>
      <v-col cols="12">
        <h3 class="mt-15 mb-0">
          {{ $t("title.bookAndChapterData") }}
        </h3>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="py-0">
        <h5>
          {{ $t("form.title") }}
        </h5>
        <v-row>
          <v-col class="py-0">
            <v-text-field
              v-model="publication.bookandchapter.title"
              :label="$t('form.title')"
              outlined
              readonly
              :background-color="
                'title' in bookandchapterFieldsChanged
                  ? getFieldsChangedColor
                  : ''
              "
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" class="py-0">
        <h5>
          {{ $t("form.bookandchapter.type") }}
        </h5>
        <v-row>
          <v-col class="py-0">
            <v-select
              outlined
              v-model="publication.bookandchapter.type"
              :label="$t('form.bookandchapter.type')"
              :items="bookAndChapterTypes"
              item-value="value"
              item-text="text"
              readonly
              :background-color="
                'type' in bookandchapterFieldsChanged
                  ? getFieldsChangedColor
                  : ''
              "
            />
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="6" class="py-0">
        <h5>{{ $t("editorial") }}</h5>
        <v-row>
          <v-col class="py-0">
            <v-select
              outlined
              v-model="publication.bookandchapter.editorial"
              :label="$t('editorial')"
              :items="editorials"
              item-value="id"
              item-text="name"
              readonly
              :background-color="
                'editorial' in bookandchapterFieldsChanged
                  ? getFieldsChangedColor
                  : ''
              "
            >
            </v-select>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" class="py-0">
        <h5>
          {{ $t("form.bookandchapter.num_pages") }}
        </h5>
        <v-row>
          <v-col class="py-0">
            <v-text-field
              v-model="publication.bookandchapter.num_pages"
              :label="$t('form.bookandchapter.num_pages')"
              required
              outlined
              type="number"
              readonly
              :background-color="
                'num_pages' in bookandchapterFieldsChanged
                  ? getFieldsChangedColor
                  : ''
              "
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="6" class="py-0">
        <h5>
          {{ $t("form.bookandchapter.publication_date") }}
        </h5>
        <v-row>
          <v-col class="py-0">
            <v-text-field
              v-model="publication.bookandchapter.publication_date"
              :label="$t('form.bookandchapter.publication_date')"
              required
              outlined
              readonly
              :background-color="
                'publication_date' in bookandchapterFieldsChanged
                  ? getFieldsChangedColor
                  : ''
              "
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <h5>{{ $t("form.editors") }}</h5>
    <SelectPeopleList
      :items-selected="book_editors"
      :disabled-form="true"
      :change-color="'editors' in bookandchapterFieldsChanged"
    />
    <h5>
      {{ $t("form.bookandchapter.editors_text") }}
    </h5>
    <v-row>
      <v-col cols="12" class="py-0">
        <v-text-field
          v-model="publication.bookandchapter.editors_text"
          :label="$t('form.bookandchapter.editors_text')"
          outlined
          readonly
          :background-color="
            'editors_text' in bookandchapterFieldsChanged
              ? getFieldsChangedColor
              : ''
          "
        />
      </v-col>
    </v-row>
    <h5 :class="'book_location' in bookandchapterFieldsChanged ? 'amber' : ''">
      {{ $t("form.bookandchapter.book_location") }}
    </h5>
    <v-row>
      <v-col cols="12" sm="6" lg="3" class="py-0">
        <v-text-field
          v-model="publication.bookandchapter.book_location.chapter"
          :label="$t('form.bookandchapter.chapter')"
          required
          outlined
          readonly
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="6" lg="3" class="py-0">
        <v-text-field
          v-model="publication.bookandchapter.book_location.page_number"
          :label="$t('form.bookandchapter.pageNumber')"
          required
          outlined
          readonly
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="6" lg="3" class="py-0">
        <v-text-field
          v-model="publication.bookandchapter.book_location.page_start"
          :label="$t('form.bookandchapter.pageStart')"
          required
          outlined
          readonly
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="6" lg="3" class="py-0">
        <v-text-field
          v-model="publication.bookandchapter.book_location.page_end"
          :label="$t('form.bookandchapter.pageEnd')"
          required
          outlined
          readonly
        ></v-text-field>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from "axios";
import SelectPeopleList from "../../reusables/SelectPeopleList";
import publication_model from "../../../mixins/model_utils/publication_model";
export default {
  components: { SelectPeopleList },
  mixins: [publication_model],
  name: "ReviewModifyArticle",
  props: {
    publication: Object,
    fieldsChanged: Object
  },
  data: () => ({
    book_editors: []
  }),

  created() {
    this.getEditors();
    this.getEditorials();
    this.getBookAndChapterTypes();
  },

  computed: {
    bookandchapterFieldsChanged() {
      if (this.fieldsChanged.bookandchapter !== undefined) {
        return this.fieldsChanged.bookandchapter;
      } else {
        return {};
      }
    }
  },

  methods: {
    getEditors() {
      if (
        this.publication.bookandchapter != null &&
        this.publication.bookandchapter.editors.length
      ) {
        const path = this.$store.state.endpoint + "/person";
        axios
          .get(path)
          .then(response => {
            this.publication.bookandchapter.editors.forEach(id => {
              const item = response.data.find(
                itemResponse => itemResponse.id === id
              );
              if (item !== undefined) {
                this.book_editors.push({
                  id: item.id,
                  name: item.preferred_name.given_name
                });
              }
            });
          })
          .catch(error => {
            console.log(error);
          });
      }
    }
  }
};
</script>
